export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9616.678bf11f.jpg";